const category = 'Webinar';

export const SegmentWebinarEvent = {
    JOIN_WEBINAR_CLICKED: { category, event: 'Join webinar clicked in a pop-up' },
    WEBINAR_POPUP_SHOWED: { category, event: 'Webinar pop-up showed' },
}
